import React, {useState} from 'react';
import {isEmail, setElementAttribute} from "../utils/common-utils.ts";
import ReactDOM from "react-dom/client";
import {renderTextField, renderTextArea, renderEmailField, renderDropdown} from "./fields/FormFields.tsx";

export const renderFormVideoHelpEn = (div: string) => {
    const root = document.getElementById(div)
    if (root) {
        ReactDOM.createRoot(root).render(<React.StrictMode><FormVideoHelpEn/></React.StrictMode>)
    }
}
const FormVideoHelpEn = () => {
    const [choiceOS, setChoiceOS] = useState('select');
    const [choiceProv, setChoiceProv] = useState('select');
    const [connection, setConnection] = useState('');
    const [otherOS, setOtherOS] = useState('');
    const [browser, setBrowser] = useState('select');
    const [browserOther, setBrowserOther] = useState('');
    const [city, setCity] = useState('');
    const [errorDetails, setErrorDetails] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const renderChoiceOs = () => {
        const inputData = {
            name: 'operating-system-choice',
            id: 'OSselector',
            label: 'Operating System',
            option: [
                {label: '- Select -', value: 'select'},
                {label: 'Windows', value: 'Windows'},
                {label: 'Mac', value: 'Mac'},
                {label: 'Linux', value: 'Linux'},
                {label: 'Apple iOS - iPad / iPhone', value: 'Apple iOS - iPad / iPhone'},
                {label: 'Andriod', value: 'Andriod'},
                {label: 'Other', value: 'Other'},
            ],
            required: true,
            description: 'field_description_OS',
            message: 'Please select your operating system. If your operating system is not in the list please select "Other".',
            errorMessageID: 'OS_error_message',
            visible: false
        };

        return renderDropdown(inputData, choiceOS, setChoiceOS, submitted);
    }

    const renderOtherOS = () => {
        const inputData = {
            name: 'other-OS',
            id: 'otherOS',
            label: 'Operating System - Other',
            type: 'text',
            inputMode: 'text',
            value: '',
            required: false,
            autoComplete: 'off',
            description: 'field_description_OSother',
            message: 'If your operating system is not in the list, please provide the name of your operating system.',
            errorMessageID: '',
            visible: true
        }
        return renderTextField(inputData, otherOS, setOtherOS, submitted);
    }

    const renderBrowser = () => {
        const inputData = {
            name: 'browser',
            id: 'browserSelect',
            label: 'Browser Type',
            required: true,
            option: [
                {label: '- Select -', value: 'select'},
                {label: 'Edge', value: 'Edge'},
                {label: 'Firefox', value: 'Firefox'},
                {label: 'Safari', value: 'Safari'},
                {label: 'Chrome', value: 'Chrome'},
                {label: 'Other', value: 'Other'},
            ],
            description: 'field_description_browser',
            message: 'Please select your web browser. If your web browser is not in the list please select "Other".',
            errorMessageID: 'browser_error_message',
            visible: false
        };

        return renderDropdown(inputData, browser, setBrowser, submitted);
    }

    const renderBrowserOther = () => {
        const inputData = {
            name: 'browser_other',
            id: 'other-browser',
            label: 'Browser - Other',
            type: 'text',
            inputMode: 'text',
            value: '',
            required: false,
            autoComplete: 'off',
            description: 'field_description_browserOther',
            message: 'If your web browser is not in the list, please provide the name of your browser.',
            errorMessageID: '',
            visible: false
        }
        return renderTextField(inputData, browserOther, setBrowserOther, submitted);
    }

    const renderCity = () => {
        const inputData = {
            name: 'city',
            id: 'location',
            label: 'Your City',
            type: 'text',
            inputMode: 'text',
            value: '',
            required: true,
            autoComplete: 'address-level2',
            description: 'field_description_city',
            message: 'Please provide your location.',
            errorMessageID: 'location_error_message',
            visible: false
        }
        return renderTextField(inputData, city, setCity, submitted);
    }

    const renderChoiceProv = () => {
        const inputData = {
            name: 'province-territory',
            id: 'province',
            label: 'Your Province / Territory',
            option: [
                {label: 'Select your Province or Territory', value: 'select'},
                {label: 'British Columbia', value: 'British Columbia'},
                {label: 'Alberta', value: 'Alberta'},
                {label: 'Saskatchewan', value: 'Saskatchewan'},
                {label: 'Manitoba', value: 'Manitoba'},
                {label: 'Ontario', value: 'Ontario'},
                {label: 'Québec', value: 'Québec'},
                {label: 'New Brunswick', value: 'New Brunswick'},
                {label: 'Prince Edward Island', value: 'Prince Edward Island'},
                {label: 'Nova Scotia', value: 'Nova Scotia'},
                {label: 'Newfoundland and Labrador', value: 'Newfoundland and Labrador'},
                {label: 'Nunavut', value: 'Nunavut'},
                {label: 'Northwest Territories', value: 'Northwest Territories'},
                {label: 'Yukon', value: 'Yukon'},
            ],
            required: true,
            description: 'field_description_province',
            message: 'Please select your province or territory.',
            errorMessageID: 'province_error_message',
            visible: false
        };

        return renderDropdown(inputData, choiceProv, setChoiceProv, submitted);
    }

    const renderConnection = () => {
        const inputData = {
            name: 'connection',
            id: 'connection',
            label: 'Internet Connection Type',
            required: true,
            option: [
                {label: '- Select -', value: 'select'},
                {label: 'Cable', value: 'Cable'},
                {label: 'Fibre', value: 'Fibre'},
                {label: 'Satellite', value: 'Satellite'},
                {label: 'Fixed Wireless', value: 'Fixed Wireless'},
                {label: 'Mobile', value: 'Mobile'},
                {label: 'DSL', value: 'DSL'},
            ],
            description: 'field_description_connection',
            message: 'Please select your internet connection type.',
            errorMessageID: 'connection_error_message',
            visible: false
        };
        return renderDropdown(inputData, connection, setConnection, submitted);
    }

    const renderErrorDetails = () => {
        const inputData = {
            name: 'error_details',
            id: 'errorDetails',
            label: 'Please explain the details of the problem you are experiencing.',
            required: true,
            inputMode: 'text',
            description: 'field_description_errorDetails',
            message: 'Please provide as much detail as possible, including any error messages you may have received.',
            errorMessageID: 'errorDetails_error_message',
            visible: false
        }
        return renderTextArea(inputData, errorDetails, setErrorDetails, submitted);
    }

    const renderEmailDetails = () => {
        const inputData = {
            name: 'email',
            id: 'emailAddress',
            autoComplete: 'email',
            label: 'Email',
            type: 'email',
            required: true,
            description: 'field_description_email',
            message: 'Please provide a valid email address.',
            errorMessageID: 'email_error_message',
            visible: false,
            success: 'Thank You for your email address.'
        }
        return renderEmailField(inputData, emailAddress, setEmailAddress, submitted);
    }

    const handleSubmit = (e: any) => {
        e.preventDefault();
        const hasErrors = !choiceProv || choiceProv === 'select' || choiceProv === '' || !city || !emailAddress || !isEmail(emailAddress) ||
            !choiceOS || choiceOS === 'select' || choiceOS === ''|| !connection || connection === 'select' || connection === '' || !browser || browser === 'select' || browser === '' || !errorDetails;
        setSubmitted(true);
        const mailSubject = "?subject=Submission from Video Help English";
        const mailBody = `&body=Email Address: ${emailAddress}%0D%0A City: ${city}%0D%0A Province: ${choiceProv}%0D%0A Operating System: ${choiceOS}%0D%0A Other OS: ${otherOS}%0D%0A Browser Type: ${browser}%0D%0A Browser Other: ${browserOther}%0D%0A Internet Connection Type: ${connection}%0D%0A Error Details: ${errorDetails}%0D%0A`;
        const sendMail = "mailto:videohelp@cpac.ca";
        const errorMessages = document.querySelector("#error_summary") as HTMLElement | null;
        if (hasErrors) {    
            setElementAttribute("error_summary", "aria-labelledby", "error_summary_heading");
            document.getElementById("error_summary")?.focus();
        } else {
            window.open(sendMail + mailSubject + mailBody);
            e.target.reset();
            setChoiceOS('select');
            setChoiceProv('select');
            setConnection('select');
            setOtherOS('');
            setBrowser('select');
            setBrowserOther('');
            setCity('');
            setErrorDetails('');
            setEmailAddress('');
            setSubmitted(false);
            errorMessages?.removeAttribute("aria-labelledby");
        }
    }

    return (
        <>
            {
                <div id="form_wrapper" className="form_wrapper">
                    <h2>Let us know how we can help</h2>
                    <div id='error_summary' aria-live="assertive" tabIndex={-1}>
                        {submitted && (!choiceProv || choiceProv === 'select' || choiceProv === '' || !city || !emailAddress || !isEmail(emailAddress) ||
                        !choiceOS || choiceOS === 'select' || choiceOS === ''|| !connection || connection === 'select' || connection === '' || !browser || browser === 'select' || browser === '' || !errorDetails) ? <h2 id='error_summary_heading' className='error_message invalid'>There are errors in the form.<br/><span>Please correct the errors and re-submit.</span></h2> : null}
                        <ul className="reg-list">
                        {submitted && (!choiceOS || choiceOS === 'select' || choiceOS === '') ? <li id='OS_error_message' className='error_message invalid'><a href="#OSselector"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Please select your Operating System.</a></li> : null}
                        {submitted && (!browser || browser === 'select' || browser === '') ? <li id='browser_error_message' className='error_message invalid'><a href="#browserSelect"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Please select your Web Browser.</a></li> : null}
                        {submitted && (!connection || connection === 'select' || connection === '') ? <li id='connection_error_message' className='error_message invalid'><a href="#connection"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Please select your Internet Connection Type.</a></li> : null}
                        {submitted && !errorDetails ? <li id='errorDetails_error_message' className='error_message invalid'><a href="#errorDetails"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Please provide any errors you are experiencing.</a></li> : null}
                        {submitted && !city ? <li id='location_error_message' className='error_message invalid'><a href="#location"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Please provide your location.</a></li> : null}
                        {submitted && (!choiceProv || choiceProv === 'select' || choiceProv === '') ? <li id='province_error_message' className='error_message invalid'><a href="#province"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Please select your province or territory.</a></li> : null}
                        {submitted && ((!emailAddress) || (!isEmail(emailAddress)) || (emailAddress && !isEmail(emailAddress))) ? <li id='email_error_message' className='error_message invalid'><a href="#emailAddress"><img alt="" className="error-icon" src="/static-assets/images/common/error.svg" /> Please provide a valid email address.</a></li> : null}
                        </ul>
                    </div>
                    <form aria-label="Video Help Form" onSubmit={(e) => handleSubmit(e)} noValidate>
                        <div className="form_body">
                            {renderChoiceOs()}
                            {choiceOS === 'Other' ? renderOtherOS() : ''}
                            {renderBrowser()}
                            {browser === 'Other' ? renderBrowserOther() : ''}
                            {renderConnection()}
                            {renderErrorDetails()}
                            {renderCity()}
                            {renderChoiceProv()}
                            {renderEmailDetails()}
                        </div>
                        <div className='form_footer left_label'>
                            <button type="submit" name='submit' className="btn--primary">Send by Email</button>
                        </div>
                    </form>
                </div>
            }
        </>
    )
}

export default FormVideoHelpEn;